import { CalendarRange, DoorOpen, Map as Mapa, MonitorSmartphone } from "lucide-react";

const ITENS = [
  { icone: DoorOpen, titulo: "Salas na consulta", texto: "Cada cadeira cadastrada; duas consultas nunca caem na mesma sala ao mesmo tempo." },
  { icone: Mapa, titulo: "Planta da clínica", texto: "Monte a maquete do espaço e veja ao vivo quem está em cada sala." },
  { icone: CalendarRange, titulo: "Agenda por sala", texto: "O dia em colunas por sala; arraste a consulta para trocar de cadeira." },
  { icone: MonitorSmartphone, titulo: "Modo recepção", texto: "A planta em tela cheia no monitor do balcão, só com as iniciais do paciente." },
];

/** O que as salas fazem, para quem ainda não tem o plano pago. */
export function PlanoPagoSalas({ compacto = false }: { compacto?: boolean }) {
  return (
    <div className={compacto ? "p-6" : "rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm sm:p-8 dark:border-border dark:bg-card"}>
      <span className="rounded-full bg-brand-50 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-700 dark:bg-primary/10 dark:text-primary">
        Plano pago
      </span>
      <h2 className="mt-3 text-lg font-bold text-zinc-900 dark:text-foreground">Salas e planta da clínica</h2>
      <p className="mt-1 max-w-2xl text-sm text-zinc-500 dark:text-muted-foreground">
        Saiba qual cadeira está livre, quem está sendo atendido e quem já chegou, sem perguntar pelo corredor.
      </p>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {ITENS.map((i) => (
          <div key={i.titulo} className="flex gap-3 rounded-xl border border-zinc-200 p-4 dark:border-border">
            <i.icone className="mt-0.5 h-5 w-5 shrink-0 text-brand-600 dark:text-primary" />
            <div>
              <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">{i.titulo}</p>
              <p className="text-xs text-zinc-500 dark:text-muted-foreground">{i.texto}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-6 text-xs text-zinc-500 dark:text-muted-foreground">Fale com a equipe do DentalBook para liberar o plano pago.</p>
    </div>
  );
}
